function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import $ from 'jquery';
import { DragListener } from "../utils/index.js";
/**
 * IntersectionSplitter is a 2D drag handle that appears at the intersection of
 * two perpendicular splitters (e.g., where a horizontal splitter crosses a vertical splitter).
 *
 * This allows users to drag in both X and Y dimensions simultaneously to resize both
 * rows and columns at the same time, similar to VS Code's window management.
 *
 * Key differences from standard Splitter:
 * - Supports 2D mouse movement (both X and Y offsets)
 * - Uses a `move` (4-way) cursor
 * - Positioned at the intersection point
 * - Emits drag events with both offsetX and offsetY
 */
export default class IntersectionSplitter {
  /**
   * Creates a new IntersectionSplitter.
   *
   * @param size The size of the splitter in pixels (usually matches border width)
   * @param grabSize The size of the grab area (can be larger for usability)
   */
  constructor(size, grabSize) {
    _defineProperty(this, "_size", void 0);
    _defineProperty(this, "_grabSize", void 0);
    _defineProperty(this, "_hitAreaSize", void 0);
    _defineProperty(this, "_dragListener", void 0);
    _defineProperty(this, "element", void 0);
    this._size = size;
    this._grabSize = grabSize < size ? size : grabSize;
    this._hitAreaSize = Math.max(this._grabSize, 14);
    this.element = this._createElement();
    this._dragListener = new DragListener(this.element);
  }

  /**
   * Listen to events on this intersection splitter.
   *
   * @param event The event name ('drag', 'dragStart', 'dragStop')
   * @param callback The callback function
   * @param context The context to bind to
   */
  on(event, callback, context) {
    var _this$_dragListener;
    (_this$_dragListener = this._dragListener) === null || _this$_dragListener === void 0 || _this$_dragListener.on(event, callback, context);
  }

  /**
   * Clean up and remove this intersection splitter from the DOM.
   */
  _$destroy() {
    var _this$_dragListener2;
    (_this$_dragListener2 = this._dragListener) === null || _this$_dragListener2 === void 0 || _this$_dragListener2.destroy();
    this._dragListener = null;
    this.element.remove();
  }

  /**
   * Create the DOM element for the intersection splitter.
   *
   * The element is an invisible square grab area positioned at the crossing
   * point of two perpendicular splitters. It allows dragging in both dimensions.
   *
   * @returns The created jQuery element
   */
  _createElement() {
    var dragHandle = $('<div class="lm_drag_handle"></div>');
    var element = $('<div class="lm_intersection_splitter"></div>');
    element.append(dragHandle);
    element.css({
      width: this._hitAreaSize,
      height: this._hitAreaSize
    });

    // Prevent the mousedown from bubbling to the parent splitter's DragListener,
    // which would otherwise start a 1D drag in parallel.
    element.on('mousedown touchstart', event => {
      event.stopPropagation();
    });
    return element;
  }
}
//# sourceMappingURL=IntersectionSplitter.js.map